<div class="text-center"  *ngIf="car">
  <div style="max-width:400px;" class="mx-auto">
    <form [formGroup]="formMain" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12">
          <app-control-text-input [placeholder]="'Imię'" [label]="'Imię'" [bindValue]="'FirstName'" [model]="car" [controlName]="inputFirstName" [maxLength]="30" [minLength]="3">
          </app-control-text-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-control-text-input [placeholder]="'Nazwisko'" [label]="'Nazwisko'" [bindValue]="'LastName'" [model]="car" [controlName]="inputLastName" [maxLength]="50" [minLength]="3">
          </app-control-text-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-control-telephone-input [placeholder]="'Nr tel komórkowego'" [label]="'Telefon'" [bindValue]="'PhoneNr'" [model]="car" [controlName]="inputPhoneNr" [isLandlinePhone]="false" (ngValidationError)="onValidationTelephone($event)">
          </app-control-telephone-input>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <app-control-email-input [placeholder]="'Mail'" [label]="'Mail'" [bindValue]="'Mail'" (ngValidationError)="onValidationEmail($event)" [model]="car" [controlName]="inputMail">
          </app-control-email-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-control-text-input [isDisabled]="true" [placeholder]="'Marka'" [label]="'Marka'" [bindValue]="'Brand'" [model]="car">
          </app-control-text-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-control-text-input [isDisabled]="true" [placeholder]="'VIN'" [label]="'VIN'" [bindValue]="'Vin'" [model]="car">
          </app-control-text-input>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <app-control-checkbox-input [label]="'Wyrażam zgodę na przetwarzanie przez Point-S  moich danych osobowych w postaci imienia, nazwiska i adresu do korespondencji w celu przesyłania mi informacji marketingowych dotyczących produktów i usług oferowanych przez Point-S za pomocą poczty elektronicznej.'"
                                      [bindValue]="'IsAldConsentToAdvertising'"
                                      [model]="car">
          </app-control-checkbox-input>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <button style="margin-bottom: 20px;" [disabled]="!IsFormValid()" class="btn btn-primary form-control">
            Zapisz zmiany
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-container *ngIf="!car">
  <app-spinner-full-block></app-spinner-full-block>
</ng-container>
